import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { pathToRoute } from "./parseSummary";

export default function DocsSidebar({ items, onNavigate }) {
  const theme = useTheme();
  const location = useLocation();

  return (
    <Box
      component="nav"
      aria-label="Docs navigation"
      sx={{
        py: { xs: 2, md: 3 },
        pr: { xs: 0, md: 2 },
      }}
    >
      <Stack spacing={0.5}>
        {items.map((item, i) => {
          if (item.type === "section") {
            return (
              <Typography
                key={`s-${i}`}
                variant="overline"
                sx={{
                  display: "block",
                  mt: i === 0 ? 0 : 2.5,
                  mb: 0.5,
                  letterSpacing: 1.2,
                  fontWeight: 800,
                  color: "text.secondary",
                  fontSize: "0.72rem",
                }}
              >
                {item.title}
              </Typography>
            );
          }

          const route = pathToRoute(item.path);
          // Exact match only — otherwise a folder's "Overview" link would stay
          // highlighted while browsing any child page inside that folder.
          const active = location.pathname === route;

          return (
            <Box
              key={`l-${i}-${item.path}`}
              component={RouterLink}
              to={route}
              onClick={onNavigate}
              sx={{
                display: "block",
                pl: 1 + item.depth * 1.5,
                pr: 1,
                py: 0.6,
                borderRadius: 1,
                color: active ? "primary.main" : "text.primary",
                fontWeight: active ? 800 : 500,
                fontSize: "0.88rem",
                textDecoration: "none",
                borderLeft: active
                  ? `2px solid ${theme.palette.primary.main}`
                  : "2px solid transparent",
                backgroundColor: active
                  ? alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.12 : 0.08)
                  : "transparent",
                transition: "background-color 150ms ease, color 150ms ease",
                "&:hover": {
                  backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.mode === "dark" ? 0.1 : 0.06
                  ),
                  color: "primary.main",
                  textDecoration: "none",
                },
              }}
            >
              {item.label}
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}
